import React, { ComponentType } from "react";
import { Button } from "@xometry/xometry_loft";
import { useBulkUpload } from "./CustomerRFQ.context";
import {
  DragZone,
  FileListItem,
  FileUploadContainer,
  FullWidthRow,
} from "./CustomerRFQ.style";
import { useConfig } from "../proposals/contexts/configContext";

type DropZoneWrapperType = ComponentType<{
  onClick?: () => void;
  children?: React.ReactChildren;
}>;

/* eslint-disable react/prop-types */
const InnerDragZone: DropZoneWrapperType = ({ onClick }) => {
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <DragZone onClick={onClick}>
      <i className="far fa-cloud-upload" />
      <div>
        Drag and Drop or <span>browse</span>
      </div>
    </DragZone>
  );
  /* eslint-enable jsx-a11y/click-events-have-key-events */
  /* eslint-enable jsx-a11y/no-static-element-interactions */
};

// just a helper function to format the number ok KB in the file
function bytesToFormatedKb(x: number) {
  return (x / 1000).toFixed(2);
}

export const FormStepperFileUpload = () => {
  const {
    data: { files },
    actions: { showFileSelector, removeFile, withDropZone },
  } = useBulkUpload();

  const { service } = useConfig();

  const trackUpload = () => {
    analytics.track("Customer RFQ File Upload Clicked", {
      service,
      context: "Form Stepper",
    });
  };

  const UploadArea: DropZoneWrapperType = withDropZone(
    InnerDragZone,
    trackUpload
  );

  return (
    <FileUploadContainer>
      <h2>Upload Files</h2>
      <p>
        Provide relevant files, drawings, part specifications, quantity, and any
        other information that could improve our ability to provide you with an
        accurate quote.
        {` `}
        <span
          id="appcue-see-file-upload-example"
          className="see-an-example-target"
        />
      </p>
      <UploadArea
        onClick={() => {
          trackUpload();
          showFileSelector();
        }}
      />
      <FullWidthRow>
        {files.map((file, index) => (
          <FileListItem key={file.name}>
            <div>{file.name}</div>
            <div>
              <span>
                {file.file?.size && `${bytesToFormatedKb(file.file.size)} KB`}
              </span>
              <Button link onClick={() => removeFile(index)}>
                <i className="fa-regular fa-trash-can" />
              </Button>
            </div>
          </FileListItem>
        ))}
        {!files.length && (
          <div>
            Useful files to include:
            <ul>
              <li>Bill of Materials</li>
              <li>Statement of Work</li>
              <li>Part Files</li>
              <li>Technical Drawings</li>
            </ul>
          </div>
        )}
      </FullWidthRow>
    </FileUploadContainer>
  );
};
